module.exports = __webpack_public_path__ + "img/12.9eb2ee7f.jpg";